import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { BoxWrapper } from './CommonPurchase.styles';
import {
  ActionRow,
  DetailGrid,
  DetailItem,
  DocChip,
  DocChips,
  InfoBoxGrid,
  InfoCard,
  InfoCardHeader,
  InfoCardTitle,
  PrimaryActionButton,
  SectionLabel,
  StatusPill,
} from './InfoBoxV2.styles';
import ProductsTableCard from './ProductsTableCard';
import {
  getDDFDocument, houseTypes, ownerTypes, safeCapitalizeWords,
} from '../../../../constants';
// import MessagesModal from '../../../elements/MessagesModal';
import { downloadFile } from '../../../../../services/axios-client/axeHelpers';
import axe from '../../../../../services/axios-client/axiosClient';
import { apiDownloadDocument } from '../../../../../services/axios-client/axeCommons';
import { getBrokeragePerPayment, isNewBrokerageSystem } from '../../../../helpers/brokerageHelpers';

function InfoBoxHouse({
  insuranceRequest,
  // messagesModalData,
  rc_quotation,
  risk_quotations,
  statuses,
}) {
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const downloadPreventive = async () => {
    const res = await axe.get(
      `/quotations/${rc_quotation.id}/preventivo/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  const downloadResourceDocs = async (id) => {
    const res = await axe.get(`/download-resource-document/${id}/0`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  const DDF_document = getDDFDocument(rc_quotation, insuranceRequest);

  const downloadDocument = async (documentId) => {
    if (documentId === undefined) {
      return;
    }
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (rc_quotation !== null) {
      quoteInProccessAmount = parseFloat(rc_quotation.amount);
    }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        risksTotalAmount += parseFloat(item.amount);
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount + (rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation));

    return total.toFixed(2);
  };

  return (
    <>
      <BoxWrapper>
        <InfoBoxGrid>
          <InfoCard className="documents-status-step-one pagament-status-step-one">
            <InfoCardHeader>
              <InfoCardTitle>Riepilogo</InfoCardTitle>
              <StatusPill>{statuses.find((stat) => stat.id === rc_quotation.status).name}</StatusPill>
            </InfoCardHeader>
            <DetailGrid>
              <DetailItem className="full">
                <dt>Cliente</dt>
                <dd>
                  {insuranceRequest.customer.gender !== 'G'
                    ? `${insuranceRequest.customer.name} ${insuranceRequest.customer.surname}`
                    : insuranceRequest.customer.business_name}
                </dd>
              </DetailItem>
              {insuranceRequest.is_offline === 0 && (
                <>
                  <DetailItem>
                    <dt>Tipo Abitazione</dt>
                    <dd>
                      {
                        houseTypes.find(
                          (type) => type.id === insuranceRequest.house.house_type,
                        ).name
                      }
                    </dd>
                  </DetailItem>
                  <DetailItem>
                    <dt>Tipologia Propietario</dt>
                    <dd>
                      {
                        ownerTypes.find(
                          (type) => type.id === insuranceRequest.house.owner_typology,
                        ).name
                      }
                    </dd>
                  </DetailItem>
                  <DetailItem>
                    <dt>La superficie</dt>
                    <dd>
                      {insuranceRequest.house.square_meters}
                      m
                      <sup>2</sup>
                    </dd>
                  </DetailItem>
                  <DetailItem>
                    <dt>Provincia Abitazione</dt>
                    <dd>
                      {insuranceRequest.house.province.name}
                      (
                      {insuranceRequest.house.province.car_plate_symbol}
                      )
                    </dd>
                  </DetailItem>
                </>
              )}
              <DetailItem>
                <dt>Inizio Copertura</dt>
                <dd>
                  {moment(insuranceRequest.policy_effective_date).format(
                    'DD-MM-YYYY',
                  )}
                </dd>
              </DetailItem>
            </DetailGrid>

            <SectionLabel>Documenti</SectionLabel>
            <DocChips>
              {rc_quotation.company_id == 8
                && (
                  <DocChip
                    type="button"
                    onClick={() => downloadResourceDocs(15)}
                  >
                    Informazioni Precontrattuali Casa
                  </DocChip>
                )}
              {rc_quotation.company_id == 16
                && (
                  <DocChip
                    type="button"
                    onClick={() => downloadResourceDocs(39)}
                  >
                    Informazioni Precontrattuali Casa
                  </DocChip>
                )}
              {rc_quotation.company_id == 1001
                && (
                  <DocChip
                    type="button"
                    onClick={() => downloadResourceDocs(45)}
                  >
                    Informazioni Precontrattuali Casa
                  </DocChip>
                )}
              <DocChip type="button" onClick={() => downloadPreventive()}>
                Preventivo
              </DocChip>
            </DocChips>

            <ActionRow>
              <PrimaryActionButton
                type="button"
                onClick={() => downloadDocument(DDF_document.id)}
              >
                Scarica Documento Da Firmare
              </PrimaryActionButton>
            </ActionRow>
          </InfoCard>

          <ProductsTableCard total={getTotal()}>
            <tr>
              <td>{rc_quotation.product.name}</td>
              <td>
                {rc_quotation.company_id !== null
                  ? rc_quotation.company.name
                  : rc_quotation.preventivas_company.company_name}
              </td>
              <td>
                {parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            {risk_quotations
              && risk_quotations.map((quote, index) => (
                <tr key={index}>
                  <td>
                    {
                      safeCapitalizeWords(quoteTypes.find(
                        (type) => type.id === quote.quote_type,
                      ).name)
                    }
                  </td>
                  <td>{quote.company.name}</td>
                  <td>
                    {quote.amount != 0 && (
                      <>
                        {parseFloat(quote.amount).toFixed(2)}
                        {' '}
                        &euro;
                      </>
                    )}
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                Brokeraggio
                {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) && <span className="text-success fw-bold"> (Pagato)</span>}
              </td>
              <td />
              <td>
                {parseFloat(getBrokeragePerPayment(rc_quotation)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            <tr>
              <td>Spese Di Emissione</td>
              <td />
              <td>
                {rc_quotation.payment_frequency === 1
                  ? parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                  : parseFloat(
                    (parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                    / rc_quotation.payment_frequency,
                  ).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
          </ProductsTableCard>
        </InfoBoxGrid>
      </BoxWrapper>
      {/* <MessagesModal
        {...messagesModalData}
        threads={insuranceRequest.threads}
      /> */}
    </>
  );
}

export default InfoBoxHouse;
